module.exports = __webpack_public_path__ + "media/images/Kitchen Cabinets with Plants-bdcb6743.jpg";